'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ActionTypes$SEND_ONL;

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _clientSelectors = require('conversations-core/selectors/clientSelectors');

var _MessagesClient = require('conversations-core/data/MessagesClient');

var _ConversationsActions = require('conversations-core/actions/ConversationsActions');

var _helpers = require('conversations-core/utils/helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (_ActionTypes$SEND_ONL = {}, _defineProperty(_ActionTypes$SEND_ONL, _ActionTypes2.default.SEND_ONLINE_PRESENCE_NOTICE, function () {
  (0, _MessagesClient.sendOnlineNotice)().done();
}), _defineProperty(_ActionTypes$SEND_ONL, _ActionTypes2.default.SEND_OFFLINE_PRESENCE_NOTICE, function () {
  (0, _MessagesClient.sendOfflineNotice)().done();
}), _defineProperty(_ActionTypes$SEND_ONL, _ActionTypes2.default.SEND_PRESENCE_HEARTBEAT, function (action, getState, dispatch, client) {
  var uuid = (0, _clientSelectors.getUuid)(getState());

  client.whereNow({ uuid: uuid }, function (status) {
    var response = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (status.error) {
      return;
    }

    var channels = response.channels;

    var inPrivateChannel = (0, _helpers.containsPrivateChannel)(channels);

    if (inPrivateChannel) {
      (0, _MessagesClient.sendHeartbeat)().done();
    } else {
      var _getState = getState(),
          clientData = _getState.clientData,
          pubNubStatus = _getState.pubNubStatus;

      window.Raven.captureMessage('NOT_IN_PRIVATE_CHANNEL', {
        extra: {
          status: status,
          channels: channels,
          clientData: clientData.toJS(),
          pubNubStatus: pubNubStatus.toJS()
        }
      });

      dispatch((0, _ConversationsActions.startChannelSubscribePoll)());
    }
  });
}), _ActionTypes$SEND_ONL);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/pubNubHandlers/presenceHandlers.js
// module id = 498
// module chunks = 0